import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

const PADRAO_URL = `${API_URL}/unidades/`;

export async function getUnidades(alias, page, token) {
    const UnidadesUrl = `${PADRAO_URL}${alias}?page=${page}`;
    const headers = {
        'authorization': token
    }

    console.log(UnidadesUrl);
    const response = await axios.get(UnidadesUrl, { headers });
    return response.data;
}

export async function getUnidade(id, token) {
    const UnidadesUrl = `${PADRAO_URL}id/${id}`;
    const headers = {
        'authorization': token
    }

    console.log(UnidadesUrl);
    const response = await axios.get(UnidadesUrl, { headers });
    return response.data;
}


export async function getAllUnidades(token) {
    const headers = {
        'authorization': token
    }
    const response = await axios.get(`${PADRAO_URL}all`, { headers });
    return response.data;
}

export async function getActiveUnidades(token) {
    const headers = {
        'authorization': token
    }
    const response = await axios.get(`${PADRAO_URL}active`, { headers });
    return response.data;
}


export async function saveUnidade(id, newUnidade, token) {
    const headers = {
        'authorization': token
    };
    let response;
    if (id)
        response = await axios.patch(`${PADRAO_URL}${id}`, newUnidade, { headers });
    else
        response = await axios.post(PADRAO_URL, newUnidade, { headers });
    return response.data;
}
